const TwitterIcon = (props) => (
  <svg
    width={52}
    height={48}
    viewBox="0 0 52 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={52} height={48} rx={6} fill="url(#paint0_linear_11_534)" />
    <path
      d="M33.9525 20.7342C33.9647 20.897 33.9647 21.0597 33.9647 21.2239C33.9647 26.2284 29.8371 32 22.2897 32V31.997C20.0601 32 17.8769 31.4105 16 30.2991C16.3242 30.3351 16.65 30.3531 16.9766 30.3539C18.8243 30.3554 20.6191 29.7831 22.0727 28.7295C20.3169 28.6987 18.7772 27.642 18.2393 26.0994C18.8544 26.2089 19.4881 26.1864 20.0918 26.0341C18.1775 25.6771 16.8003 24.1247 16.8003 22.3219V22.2739C17.3707 22.5671 18.0093 22.7298 18.6626 22.7478C16.8596 21.6357 16.3039 19.4218 17.3926 17.6909C19.4759 20.057 22.5497 21.4954 25.8493 21.6477C25.5186 20.3322 25.9703 18.9538 27.0364 18.0291C28.689 16.5952 31.2882 16.6687 32.8418 18.1934C33.7607 18.0261 34.6415 17.7149 35.4475 17.2739C35.1412 18.1506 34.5001 18.8953 33.6437 19.3685C34.457 19.2801 35.2517 19.0791 36 18.7723C35.4491 19.5343 34.7552 20.198 33.9525 20.7342Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11_534"
        x1={1.93715e-7}
        y1={24}
        x2={52}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4264AA" />
        <stop offset={1} stopColor="#853F89" />
      </linearGradient>
    </defs>
  </svg>
);
export default TwitterIcon;
